<template>
  <div class="relative base-input">
    <div class="relative">
      <div class="row">
        <vue-tel-input
          class="py10 w-100 border-box brdr-none h4 col-xs-9"
          :value="value"
          @onValidate="validatePhone"
          @onInput="updatePhone"
          :autofocus="autofocus"
          :required="true"
          :valid-characters-only="true"
          :placeholder="$t('Phone Number') + ' *'"
          @blur="$emit('blur')"
        />
        <div class="bg-cl-silver col-xs-3 flex middle-xs align-center center-xs bg-cl-gray cl-white weight-100 pointer user-select"
             :class="{ 'bg-cl-light-blue' : !invalid }"
             v-on="!invalid ? { click: () => sendNumber() } : {}"
        >
          {{ $t('WYŚLIJ') }}
        </div>
      </div>
    </div>
    <ValidationMessages v-if="isError() || value === ''" :validations="validations" />
  </div>
</template>

<script>
import Vue from 'vue';
import ValidationMessages from './ValidationMessages.vue';
import VueTelInput from 'vue-tel-input';
Vue.use(VueTelInput);

export default {
  name: 'ContactInputForm',
  components: {
    ValidationMessages
  },
  data () {
    return {
      passType: 'password',
      iconActive: false,
      icon: 'visibility'
    };
  },
  props: {
    type: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    autocomplete: {
      type: String,
      required: false,
      default: ''
    },
    focus: {
      type: Boolean,
      required: false,
      default: false
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false
    },
    invalid: {
      type: Boolean,
      required: false,
      default: false
    },
    validations: {
      type: Array,
      default: () => []
    },
    validatePhone: {
      type: Function,
      default: () => []
    },
    updatePhone: {
      type: Function,
      default: () => []
    }
  },
  // computed: {
  // },
  methods: {
    sendNumber () {
      alert('test send')
    },
    isError () {
      let hasError = false;
      this.validations.forEach(val => {
        if (val.condition) {
          hasError = true;
        }
      });
      return hasError;
    },
    // setFocus sets focus on a field which has a value of 'ref' tag equal to fieldName
    setFocus (fieldName) {
      if (this.name === fieldName) {
        this.$refs[this.name].focus();
      }
    }
  },
  created () {
    if (this.type === 'password') {
      this.iconActive = true;
    }
  },
  mounted () {
    if (this.focus) {
      this.$refs[this.name].focus();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~theme/css/variables/colors";
@import "~theme/css/helpers/functions/color";
$color-tertiary: color(tertiary);
$color-black: color(black);
$color-hover: color(tertiary, $colors-background);
$color-puerto-rico: color(puerto-rico);
$color-orange: color(primary-orange);

/deep/ .vue-tel-input {
  background: inherit;
  border: 0;
  border: 1px solid #2f5fd2;
  border-radius: 0;
  padding: 0;
  font-size: 14px;
  font-family: "protipo",sans-serif;
  &:hover,
  &:focus,
  &:focus-within {
    outline: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    border-color: #2f5fd2;
  }
  input:placeholder-shown  {
    font-size: 14px;
  }
  input {
    background: transparent;
    font-family: "protipo",sans-serif;
    font-size: 14px;
    padding: 10px 0;
    box-sizing: border-box;
  }
  .vti__dropdown {
    outline: none !important;
  }
}

.icon {
  right: 6px;
  top: 10px;
  &:hover,
  &:focus {
    color: $color-hover;
  }
}
.icon {
  right: 6px;
  top: 10px;
  &:hover,
  &:focus {
    color: $color-hover;
  }
}
.user-select {
  user-select: none;
}
</style>
